import { lensCopy } from './lensCopy'
import styles from './ViewSwitch.module.css'

export type AnalyticsTableView = 'campaign' | 'product'

interface ViewSwitchProps {
  value: AnalyticsTableView
  onChange: (value: AnalyticsTableView) => void
}

const options: AnalyticsTableView[] = ['campaign', 'product']

export function ViewSwitch({ value, onChange }: ViewSwitchProps) {
  return (
    <div className={styles.switch} aria-label={lensCopy.viewAriaLabel}>
      {options.map((option) => (
        <button
          className={`${styles.button} ${value === option ? styles.active : ''}`}
          key={option}
          type="button"
          aria-pressed={value === option}
          onClick={() => onChange(option)}
        >
          {lensCopy.views[option]}
        </button>
      ))}
    </div>
  )
}
